import { createSlice } from "@reduxjs/toolkit";
import { loginApi, otpApi } from "./thunk";
import { toast } from "react-toastify";

export const initialState = {
  user: {},
  error: "", // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
  loginData: {},
  otpData: {},
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload.data;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    otpSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true;
    },
    reset_login_flag(state) {
      state.error = null;
      state.loading = false;
      state.errorMsg = false;
    },
    resetLoginData(state) {
      state.loginData = {};
    },
    resetOtpData(state) {
      state.otpData = {};
    },
    resetError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(otpApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(loginApi.fulfilled, (state, action) => {
      state.loginData = action.payload;
      state.loading = false;
    });
    builder.addCase(loginApi.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
      toast.error(action.error.message);
    });

    builder.addCase(otpApi.fulfilled, (state, action) => {
      state.otpData = action.payload;
    });
    builder.addCase(otpApi.rejected, (state, action) => {
      state.error = action.error.message;
    });
  },
});

export const {
  apiError,
  loginSuccess,
  otpSuccess,
  logoutUserSuccess,
  resetOtpData,
  reset_login_flag,
  resetLoginData,
  resetError,
} = loginSlice.actions;

export default loginSlice.reducer;
